import { render, staticRenderFns } from "./RwFlexOptInPostMessage.vue?vue&type=template&id=4ded4016"
import script from "./RwFlexOptInPostMessage.vue?vue&type=script&lang=ts"
export * from "./RwFlexOptInPostMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports